import { Spinner, Title } from '@kvdbil/components';
import React from 'react';
import styled from 'styled-components';
import StatusPageContainer from '~/App/shared/components/StatusPageContainer';

const Heading = styled(Title)`
  text-align: center;
  margin-bottom: 1rem;
`;

interface Props {
  minHeight?: number;
  unit?: 'rem' | 'vh';
  headingText?: string;
}

const StatusPageLoading = ({ minHeight = 50, unit, headingText }: Props) => {
  return (
    <StatusPageContainer $minHeight={minHeight} $unit={unit}>
      {headingText && <Heading>{headingText}</Heading>}
      <Spinner size="large" speed="fast" color="neutral" />
    </StatusPageContainer>
  );
};

export default StatusPageLoading;
